import { render, staticRenderFns } from "./SysAccManNew.vue?vue&type=template&id=3cccdef2&scoped=true"
import script from "./SysAccManNew.vue?vue&type=script&lang=js"
export * from "./SysAccManNew.vue?vue&type=script&lang=js"
import style0 from "./SysAccManNew.vue?vue&type=style&index=0&id=3cccdef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cccdef2",
  null
  
)

export default component.exports